export default {
	'UserStatusEnum_ACTIVE': 'Active',
	'UserStatusEnum_BLOCKED': 'Blocked',

	'OrderTypeEnum_DEPOSIT': 'Deposit',
	'OrderTypeEnum_WITHDRAWAL': 'Withdrawal',

	'OrderResolutionEnum_NEW': 'New',
	'OrderResolutionEnum_CONFIRM': 'Confirm',
	'OrderResolutionEnum_DECLINE': 'Declined',
	'OrderResolutionEnum_CHARGEBACK': 'Chargeback',
	'OrderResolutionEnum_APPROVED': 'Approved',

	'OrderStatusEnum_OPEN': 'Open',
	'OrderStatusEnum_IN_PROGRESS': 'In progress',
	'OrderStatusEnum_CLOSED': 'Closed',

	'DealsDirectionEnum_UP': 'Up',
	'DealsDirectionEnum_DOWN': 'Down',

	'DealsResolutionEnum_ACTIVE': 'Active',
	'DealsResolutionEnum_CLOSED': 'Closed',
	'DealsResolutionEnum_CANCELED': 'Canceled',
	'DealsResolutionEnum_PENDING': 'Pending',
	'DealsResolutionEnum_EARLY_CLOSED': 'Early closed',

	'DealsTypeEnum_HIGH_LOW': 'High/Low',

	TradingAccountStatus_NEW: 'New',
	TradingAccountStatus_ACTIVE: 'Active',
	TradingAccountStatus_DORMANT: 'Dormant',
	TradingAccountStatus_ARCHIVED: 'Archived',

	AccountStatusEnum_ACTIVE: 'Active',
	AccountStatusEnum_ARCHIVE: 'Archived',

	TradingAccountGroupTypeEnum_REAL: 'Real',
	TradingAccountGroupTypeEnum_DEMO: 'Demo',

	OrderHistoryStatusEnum_NEW: 'New',
	OrderHistoryStatusEnum_SUCCESS: 'Success',
	OrderHistoryStatusEnum_DECLINED: 'Declined',
	OrderHistoryStatusEnum_CHARGEBACK: 'Chargeback',
	OrderHistoryStatusEnum_IN_PROGRESS: 'In progress',
};